import didiaxios from '@didi/dajax/dist/dajax'
import apiConfig from '@/common/js/apiConfig'
const BASE_URL = apiConfig.BASE_API_D + '/d-op'
// X推D我参与的推荐活动信息接口
const POST_ACTIVITY_INFO = BASE_URL + '/reward/dtd/overview'
// const POST_ACTIVITY_INFO = 'https://mock.xiaojukeji.com/mock/776/d-op/reward/dtd/overview'
// X推D进行中的推荐活动接口
const POST_ACTIVITY_GOING = BASE_URL + '/reward/dtd/ongoingActivity'
// const POST_ACTIVITY_GOING = 'https://mock.xiaojukeji.com/mock/776/d-op/reward/dtd/ongoingActivity'
// X推D列表页已结束活动列表接口
const POST_ACTIVITY_FINISH_LIST = BASE_URL + '/reward/dtd/finishActivity'
// const POST_ACTIVITY_FINISH_LIST = 'https://mock.xiaojukeji.com/mock/776/d-op/reward/dtd/finishActivity'
// X推D活动详情接口
const POST_ACTIVITY_DETAIL = BASE_URL + '/reward/dtd/detail'
// const POST_ACTIVITY_DETAIL = 'https://mock.xiaojukeji.com/mock/776/d-op/reward/dtd/detail'
// X推D首页接口 V2
const POST_ACQUISTION_INDEX_V2 = BASE_URL + '/reward/dtd/index'
// const POST_ACQUISTION_INDEX_V2 = 'https://mock.xiaojukeji.com/mock/776/d-op/reward/dtd/index'
// X推D规则详情(23.03.28新)
const POST_ACQUISTION_RULES_DETAIL = BASE_URL + '/reward/dtd/rule'
// const POST_ACQUISTION_RULES_DETAIL = 'https://mock.xiaojukeji.com/mock/776/d-op/reward/dtd/rule'

export const xtdActivityInfo = function (data) {
  return requestPOST(POST_ACTIVITY_INFO, data)
}
export const xtdActivityGoing = function (data) {
  return requestPOST(POST_ACTIVITY_GOING, data)
}
export const xtdActivityFinishList = function (data) {
  return requestPOST(POST_ACTIVITY_FINISH_LIST, data)
}
export const xtdActivityDetail = function (data) {
  return requestPOST(POST_ACTIVITY_DETAIL, data)
}
export const xtdAcquisitionConfigV2 = function (data) {
  return requestPOST(POST_ACQUISTION_INDEX_V2, data)
}

export const getXtdRulesDetail = function (data) {
  return requestPOST(POST_ACQUISTION_RULES_DETAIL, data)
}

function requestPOST(url, data) {
  return didiaxios
    .request({
      url,
      method: 'POST',
      emulateJSON: true,
      needEncrypt: true,
      params: '',
      body: data,
    })
    .then(res => res.data)
    .catch(err => console.log(err))
}
